module.exports = __webpack_public_path__ + "img/H3.621f1775.png";